/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateChatMessageRequest
 */
export interface CreateChatMessageRequest {
  /**
   *
   * @type {string}
   * @memberof CreateChatMessageRequest
   */
  documentId?: string
  /**
   *
   * @type {string}
   * @memberof CreateChatMessageRequest
   */
  siteId?: string
  /**
   *
   * @type {string}
   * @memberof CreateChatMessageRequest
   */
  message?: string
}

export function CreateChatMessageRequestFromJSON(json: any): CreateChatMessageRequest {
  return CreateChatMessageRequestFromJSONTyped(json, false)
}

export function CreateChatMessageRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateChatMessageRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    documentId: !exists(json, 'document_id') ? undefined : json['document_id'],
    siteId: !exists(json, 'site_id') ? undefined : json['site_id'],
    message: !exists(json, 'message') ? undefined : json['message']
  }
}

export function CreateChatMessageRequestToJSON(value?: CreateChatMessageRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    document_id: value.documentId,
    site_id: value.siteId,
    message: value.message
  }
}
